<div class="container-fluid">

    <app-head></app-head>

    <div class="row">
        <table>
            <tr>
                <td style="height: 12vh;">
                </td>
            </tr>
            <tr>
                <td>
                </td>
            </tr>
        </table>
    </div>

    <div class="row">
        <table>
            <tr>
                <td>
                </td>
            </tr>
            <tr>
                <td>
                </td>
            </tr>
        </table>
    </div>

    <div class="row">
        <div class="col w-100">
            <br>
            <div class="container-fluid">
                <nav class="breadcrumb bg-white">
                    <a class="breadcrumb-item" href="#">首頁</a>
                    <a class="breadcrumb-item">學潛水</a>
                    <a class="breadcrumb-item">水肺複習</a>
                </nav>
            </div>
            <br>
        </div>
    </div>

    <div class="row">
        <div class="col-xl">
        </div>
        <div class="col-xl-10">
            <h3 style="font-family:DFKai-sb;">水肺複習</h3>
            <!-- 課程介紹 -->
            <div>
                <table style="text-align: justify;">
                    <tr>
                        <td class="fs-6" colspan="2">
                            <img style="float: left; margin: 5px 10px 0 0; vertical-align: text-top;" width="20%"
                                src="../../../assets/Image/Data/SSU_1.jpg" />
                            您是在渡假時快速取得執照嗎？還是取得執照後就沒有再潛水過呢？想到潛水還是會感到一些些恐懼嗎？沒關係！請參加 iDiving
                            為您準備的水肺複習班，將水肺潛水必備的技巧再次由專業教練帶著您一步步練習吧！
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">&nbsp;</td>
                    </tr>
                    <tr>
                        <td><img src="../../../assets/Image/Data/SSU_2.jpg" width="100%" /></td>
                        <td><img src="../../../assets/Image/Data/SSU_3.jpg" width="100%" /></td>
                    </tr>
                </table>
                <br>
            </div>
            <!-- 課程規劃 -->
            <div>
                <h3>課程規劃</h3>
                <table border="1" style="text-align: justify;">
                    <tr align="center">
                        <td></td>
                        <td class="fs-6">時 間</td>
                        <td class="fs-6">課 程 內 容</td>
                    </tr>
                    <tr align="center">
                        <td class="fs-6" nowrap style="vertical-align:middle;">水肺複習</td>
                        <td class="fs-6" nowrap>
                            週末下午<br />
                            2-3小時<br />
                            視狀況調整
                        </td>
                        <td class="fs-6" style="vertical-align:middle;">
                            裝備調整及組裝、蛙鞋踢動、面鏡排水、二級頭尋回與排水、<br />
                            中性浮力、入水法、下潛＆上升、重裝脫著、緊急游泳上升
                        </td>
                    </tr>
                </table>
                <br>
                <table style="text-align: justify;">
                    <tr>
                        <td><img src="../../../assets/Image/Data/SSU_4.jpg" width="100%" /></td>
                        <td><img src="../../../assets/Image/Data/SSU_5.jpg" width="100%" /></td>
                    </tr>
                </table>
                <br>
            </div>
            <!-- 開課日期 -->
            <div>
                <h3>開課日期</h3>
                <table>
                    <tr>
                        <td class="fs-6">「為 5~9 月每個周末皆可安排」，但請一周前填寫資料報名，以便安排。</td>
                    </tr>
                </table>
                <br>
            </div>
            <!-- 超值學費 -->
            <div>
                <h3>超值學費</h3>
                <table style="text-align: justify;">
                    <tr>
                        <td>
                            <Ul>
                                <li><span class="fs-6">前港泳池（兩米）為 2,000 元 / 南港泳池（五米）為 2,500 元</span></li>
                                <table width="100%" style="text-align: justify;">
                                    <tr>
                                        <td class="fs-6">包含泳池場地費、教練費、全套裝備使用！</td>
                                    </tr>
                                    <tr>
                                        <td class="fs-6">自備全部裝備者（鉛塊除外），費用可減免 500 元</td>
                                    </tr>
                                    <tr>
                                        <td class="fs-6">參加 iDiving 出團活動者，費用減半！</td>
                                    </tr>
                                </table>
                                <br>
                                <table width="100%" style="text-align: justify;">
                                    <tr>
                                        <td><img src="../../../assets/Image/Data/SSU_6.jpg" width="100%" /></td>
                                        <td><img src="../../../assets/Image/Data/SSU_7.jpg" width="100%" /></td>
                                    </tr>
                                </table>
                            </Ul>
                        </td>
                    </tr>
                </table>
                <br>
            </div>
            <!-- 報名方式 -->
            <div>
                <!-- <app-paymentmethod1000></app-paymentmethod1000> -->
                <br>
            </div>
            <!-- 學前須知 -->
            <div>
                <h3>學前須知</h3>
                <table style="text-align: justify;">
                    <tr>
                        <td>
                            <ol class="fs-6">
                                <li>學員自行放棄課程，本訓練中心將不予退費。</li>
                                <li>學員在學期間購買潛水器材享有會員優惠價。</li>
                                <li>訓練期間所提供之裝備若有穿戴不適或任何問題，請務必告知主持教練。</li>
                            </ol>
                        </td>
                    </tr>
                </table>
            </div>

        </div>
        <div class="col-xl">
        </div>
    </div>

    <div class="row">
        <table>
            <tr>
                <td>
                </td>
            </tr>
            <tr>
                <td>
                </td>
            </tr>
        </table>
    </div>

    <app-foot></app-foot>

</div>